import React, { KeyboardEvent } from 'react';
import type { NormalizedContentExplorerSlide } from './contentExplorerUtils';

type Styles = {
    readonly [key: string]: string;
};

type ContentExplorerTabsProps = {
    slides: NormalizedContentExplorerSlide[];
    activeIndex: number;
    baseId: string;
    panelId: string;
    styles: Styles;
    selectTab: (index: number) => void;
    onTabListKeyDown: (e: KeyboardEvent<HTMLDivElement>) => void;
    setUserPausedInteraction: (v: boolean) => void;
};

export function ContentExplorerTabs({
    slides,
    activeIndex,
    baseId,
    panelId,
    styles,
    selectTab,
    onTabListKeyDown,
    setUserPausedInteraction,
}: ContentExplorerTabsProps) {
    return (
        <div
            className={styles.tablist}
            role="tablist"
            aria-label="Wellness programs"
            aria-orientation="vertical"
            onKeyDown={onTabListKeyDown}
        >
            {slides.map((slide, index) => {
                const selected = index === activeIndex;
                const tabId = `${baseId}-explorer-tab-${index}`;
                const idxLabel = String(index + 1).padStart(2, '0');
                return (
                    <button
                        key={slide.id}
                        type="button"
                        role="tab"
                        id={tabId}
                        aria-selected={selected}
                        aria-controls={panelId}
                        tabIndex={selected ? 0 : -1}
                        className={`${styles.tab} ${
                            selected ? styles.tabActive : ''
                        }`}
                        onClick={() => selectTab(index)}
                        onFocus={() => setUserPausedInteraction(true)}
                    >
                        <span className={styles.tabLabel}>
                            {slide.navLabel}
                        </span>
                        <span className={styles.tabIndex}>{idxLabel}</span>
                    </button>
                );
            })}
        </div>
    );
}
